import { axios } from '@Root/API'

export const checkStudents = params => {
  return axios.get(`student-engagement/rollover-continuing/info`, { params })
}
